module.exports = __webpack_public_path__ + "img/1541744945.7becc075.jpg";